<template>
  <div id="content-box">
    <!-- video -->
    <iframe
      class="mb-10"
      v-if="type!==1 && video!==''"
      :src="videoID"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      style="width: 100%;"
      :style="iframeStyle"
    ></iframe>
    <!-- one-image -->
    <router-link
      :to="{name:'article', params:{id:path}}"
      v-if="type!==1 && video==='' && image.length===1"
    >
      <div
        class="one-img w-100"
        :class="{'type2':type===2,'type3':type===3}"
        v-lazy:background-image="image[0].thumbnail"
        :key="image.id"
      ></div>
    </router-link>
    <!-- multi-image type===2 -->
    <router-link
      :to="{name:'article', params:{id:path}}"
      v-else-if="type===2 && video==='' && image.length>1"
    >
      <hooper
        class="type2 p-0 m-0 mb-15"
        :group="path"
        :itemsToShow="2"
        :autoPlay="true"
        :playSpeed="10000"
        :wheelControl="true"
        :keysControl="false"
        :infiniteScroll="true"
      >
        <slide
          v-for="(item, index) in image"
          :key="index"
          class="d-flex align-items-center justify-content-center"
        >
          <img v-lazy="item.thumbnail" :key="item.id" />
        </slide>
      </hooper>
    </router-link>

  <hooper
      v-if="type===2 && video==='' && image.length >2"
      :group="path"
      class="type3 p-0 m-0 mt-10 line3 mb-10"
      :itemsToShow="2"
      :wheelControl="true"
      :keysControl="false"
      :infiniteScroll="true"
    >
      <slide
        v-for="(item, index) in image.slice(2)"
        :key="index"
        class="d-flex align-items-center justify-content-center"
      >
        <router-link :to="{name:'article', params:{id:path}}">
          <img v-lazy="item.thumbnail" :key="item.id" />
        </router-link>
      </slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>

    <hooper
      v-if="type===2 && video==='' && image.length != 1 && image.length <= 2"
      :group="path"
      class="type3 p-0 m-0 mt-10 line3 mb-10"
      :itemsToShow="2"
      :wheelControl="true"
      :keysControl="false"
      :infiniteScroll="true"
    >
      <slide
        v-for="(item, index) in image"
        :key="index"
        class="d-flex align-items-center justify-content-center"
      >
        <router-link :to="{name:'article', params:{id:path}}">
          <img v-lazy="item.thumbnail" :key="item.id" />
        </router-link>
      </slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>

    <!-- content -->
    <router-link :to="{name:'article', params:{id:path}}">
      <h5 class="content-title border-type-dash text-primary pb-10 m-0">{{ title }}</h5>
      <p class="border-type-dash py-10 d-flex align-items-center" v-if="time">
        <i class="material-icons text-primary">stop</i>
        {{time}}
      </p>
      <!--  eslint-disable max-len -->
      <p
        class="limit-line mt-15"
        :class="{'type1':type===1,'type2':(type===2 && image.length>=1) || (type===2 && video!==''),'sm-type2':type===2 && image.length<1 && video==='',
      'type3':(type===3 && image.length>=1) || (type===3 && video!==''),
      'sm-type3':type===3 && image.length<1 && video==='', 'no-date':!time}"
      >{{ brief }}</p>
    </router-link>

    <!-- multi-image type===3 -->
    <router-link :to="{name:'article', params:{id:path}}">
      <hooper
        v-if="type===3 && video==='' && image.length>1"
        :group="path"
        class="type3 p-0 m-0 mt-20"
        :itemsToShow="2"
        :wheelControl="true"
        :keysControl="false"
        :infiniteScroll="true"
      >
        <slide
          v-for="(item, index) in image"
          :key="index"
          class="d-flex align-items-center justify-content-center px-5"
        >
          <img v-lazy="item.thumbnail" :key="item.id" />
        </slide>
      </hooper>
    </router-link>
    <hooper
      v-if="type===3 && video==='' && image.length>1"
      :group="path"
      class="type3 p-0 m-0 mt-10"
      :class="{'line3':image.length>1 && image.length<=5}"
      :itemsToShow="2"
      :wheelControl="true"
      :keysControl="false"
      :infiniteScroll="true"
    >
      <slide
        v-for="(item, index) in image.slice(2)"
        :key="index"
        class="d-flex align-items-center justify-content-center px-5"
      >
        <router-link :to="{name:'article', params:{id:path}}">
          <img v-lazy="item.thumbnail" :key="item.id" />
        </router-link>
      </slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
    <router-link :to="{name:'article', params:{id:path}}">
      <hooper
        v-if="type===3 && video==='' && image.length>5"
        :group="path"
        class="type3 p-0 m-0 mt-10"
        :itemsToShow="2"
        :wheelControl="false"
        :keysControl="false"
        :infiniteScroll="true"
      >
        <slide
          v-for="(item, index) in image.slice(4)"
          :key="index"
          class="d-flex align-items-center justify-content-center px-5"
        >
          <img v-lazy="item.thumbnail" :key="item.id" />
        </slide>
      </hooper>
    </router-link>
  </div>
</template>
<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';

export default {
  name: 'content-box',
  components: {
    Hooper,
    Slide,
    HooperNavigation,
  },
  data() {
    return {
      iframeStyle: {
        height: this.type === 2 ? '310px' : '300px',
      },
    };
  },
  computed: {
    videoID() {
      const id = this.video.includes('http') ? this.video.split('be/')[1] : this.video;
      return `https://www.youtube.com/embed/${id}`;
    },
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '標題',
    },
    brief: {
      type: String,
      default: '簡述',
    },
    time: {
      type: String,
      default: '1999-99-99',
    },
    image: {
      type: Array,
      default: () => false,
    },
    video: {
      type: String,
      default: '',
    },
    type: {
      type: Number,
      // 1:最新消息 2:首頁活動記錄 3:活動記錄列表
      default: 0,
    },
    path: {
      type: String,
      default: 'id',
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/all.scss';

#content-box {
  background-color: white;
  border: 1px solid $secondary-white;
  border-radius: 5px;
  padding: 15px;
  @media (min-width: 992px) {
    padding: 25px;
  }
  transition: 0.3s ease-out;
  &:hover {
    box-shadow: 0px 0px 8px lighten($secondary-light, 22%);
  }
  section {
    &.hooper {
      &.type2 {
        height: 150px;
        li {
          width: 100%;
          border: 1px solid white;
          overflow: hidden;
        }
        img[lazy='loading'] {
          width: 64px;
          height: 64px;
        }
        img[lazy='loaded'] {
          height: auto;
          width: 100%;
          @media (min-width: 768px) {
            height: 100%;
            width: auto;
          }
          @media (min-width: 992px) {
            height: auto;
            width: 100%;
          }
        }
        &.line3 {
          position: relative;
          .hooper-navigation {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-between;
            .hooper-next,
            .hooper-prev {
              position: static;
            }
          }
        }
      }
      &.type3 {
        height: 150px;
        li {
          width: 100%;
          border: 1px solid white;
          overflow: hidden;
        }
        a {
          display: flex;
          width: 100%;
          height: 100%;
          justify-content: center;
          align-items: center;
          @media (min-width: 992px) {
            display: inline;
            width: auto;
            height: auto;
          }
        }
        img[lazy='loading'] {
          width: 64px;
          height: 64px;
        }
        img[lazy='loaded'] {
          width: auto;
          height: 100%;

          @media (min-width: 992px) {
            width: 100%;
            height: auto;
          }
        }
        &.line3 {
          position: relative;
          .hooper-navigation {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-between;
            .hooper-next,
            .hooper-prev {
              position: static;
            }
          }
        }
      }
      .hooper-navigation {
        z-index: 1000;
        button {
          background: rgba(0, 0, 0, 0.5);
          padding: 2px;
        }
        svg {
          path:nth-of-type(2) {
            fill: white;
          }
        }
      }
    }
  }
  .content-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    letter-spacing: 1px;
  }
  .one-img[lazy='loading'] {
    background-position: center center;
    background-size: 64px 64px;
    background-repeat: no-repeat;
    border-radius: 5px;
    margin-bottom: 15px;
    width: 100%;
    &.type2 {
      height: 300px;
    }
    &.type3 {
      height: 300px;
    }
  }
  .one-img[lazy='loaded'] {
    background-position: center center;
    background-size: cover;
    border-radius: 5px;
    margin-bottom: 15px;
    width: 100%;
    &.type2 {
      height: 310px;
    }
    &.type3 {
      height: 300px;
    }
  }
  .border-type-dash {
    border-bottom: 1px dashed $secondary-white;
  }
  .limit-line {
    margin-bottom: 0;
    letter-spacing: 1px;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    &.type1 {
      height: 40px;
      vertical-align: middle;
      -webkit-line-clamp: 2;
      &.no-date {
        height: 85px;
        -webkit-line-clamp: 4;
      }
    }
    &.type2 {
      height: 22px;
      -webkit-line-clamp: 1;
      &.no-date {
        height: 68px;
        -webkit-line-clamp: 3;
      }
    }
    &.sm-type2 {
      height: 195px;
      &.no-date {
        height: 240px;
      }
    }
    &.type3 {
      -webkit-line-clamp: 3;
    }
    &.sm-type3 {
      min-height: 260px;
      -webkit-line-clamp: 8;
    }
  }
}
</style>
